import { ILocale, ILocaleList } from 'mod/store/locale/interface';

export const defaultLocale: ILocale = {
    country: 'US',
    currency: 'USD',
    lang: 'en'
}

export function getValidLocale(localeList: ILocaleList, locale: ILocale): ILocale {
    let { country, currency, lang } = locale;
    const countryItem = localeList.find(item => item.countryCode === country);
    if (!countryItem) {
        return defaultLocale;
    }
    const { currencyList, languageList } = countryItem;
    const currencyItem = currency ? currencyList.find(item => item.code === currency) : void 0;
    if (!currencyItem) {
        currency = currencyList.find(item => item.defaultValue)?.code || currencyList[0]?.code || defaultLocale.currency;
    }
    const languageItem = lang ? languageList.find(item => item.code === lang) : void 0;
    if (!languageItem) {
        lang = languageList.find(item => item.defaultValue)?.code || languageList[0]?.code || defaultLocale.lang;
    }
    return { country, currency, lang }
}